import { useEffect } from 'react';

const usePostMessage = ({
    targetOrigin = '*',
    containerClass = null,
    messageType = 'embeddedResize',
} = {}) => {

    useEffect(() => {
      //  if (window.self === window.top) return; // only run in iframe

        let rafId = null;
        let lastHeight = 0;

        function sendHeight() {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
                document.body.style.overflow = 'hidden';

                const height = containerClass
                    ? document.getElementsByClassName(containerClass)[0]?.scrollHeight
                    ?? Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
                    : Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);

                document.body.style.overflow = '';

                if (height === lastHeight) return;
                lastHeight = height;

                window.parent.postMessage({ type: messageType, height }, targetOrigin);
            });
        }

        window.addEventListener('resize', sendHeight);

        const resizeObserver = new ResizeObserver(sendHeight);
        resizeObserver.observe(document.body);

        const mutationObserver = new MutationObserver(sendHeight);
        mutationObserver.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: false,
        });

        sendHeight();

        return () => {
            if (rafId) cancelAnimationFrame(rafId);
            window.removeEventListener('resize', sendHeight);
            resizeObserver.disconnect();
            mutationObserver.disconnect();
        };
    }, [targetOrigin, containerClass, messageType]);
};

export default usePostMessage;
